import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// Import Mixpanel to ensure it's initialized
import './utils/mixpanel';
// Import our analytics utility
import Analytics from './utils/analytics';
// Import secure protocol utility
import secureProtocol from './utils/secureProtocol';
import { storeUtmParameters, getStoredUtmParameters } from './utils/utmParameters';

// Capture UTM params immediately before React renders or routing strips the query string.
// This is the earliest possible moment — before any routing, redirects, or re-renders.
storeUtmParameters();

if (process.env.NODE_ENV === 'development') {
  console.log('[UTM] Initial capture result:', getStoredUtmParameters());
  console.log('[UTM] window.location.search:', window.location.search);
  console.log('[UTM] document.referrer:', document.referrer);
}

// Check and enforce HTTPS in production
if (secureProtocol.isHttpsRequired()) {
  if (secureProtocol.enforceHttps()) {
    // If redirect happened, stop execution
    throw new Error('Redirecting to HTTPS...');
  }
}

// Initialize analytics with error handling for privacy-sandbox
Analytics.initAnalytics();

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals((metric) => {
  // Send web vitals to Google Analytics
  Analytics.trackEvent('web-vitals', {
    ...metric,
    event_category: 'Web Vitals',
    event_label: metric.name,
    value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value)
  });
});
